export default __webpack_public_path__ + "static/2243-25b10394ff1c9eeca2994a8dbb2b4499.gif";